import { remove } from 'lodash-es';

const finder = (name: string) =>
  name
    .replace(/\[(\w+)\]/g, '.$1')
    .replace(/^\./, '')
    .split('.');

const bindDown = (key: string, obj: object) => {
  let found = key in obj ? obj[key] : {};
  found = Array.isArray(found) ? Object.values({ ...found }) : { ...found };
  obj[key] = found;
  return found;
};

export const changeObjectByNestedString = (
  obj: object,
  name: string,
  // tslint:disable-next-line: no-any
  value: any,
): object => {
  // nameのstringでvalueをupdateする。
  // nameは `me.firstname` とか `options[0].description` とかで指定できる
  const names = finder(name);
  const newObj = { ...obj };
  let found = newObj;
  for (let i = 0, n = names.length; i < n; ++i) {
    const key = names[i];
    if (i === n - 1) {
      // last
      found[key] = value;
      break;
    }
    found = bindDown(key, found);
    if (i === 0) {
      // first
      newObj[key] = found;
    }
  }
  return newObj;
};

// tslint:disable-next-line: no-any
export const getValueByNestedString = (obj: object, name: string): any => {
  const names = finder(name);
  let found = obj;
  for (let i = 0, n = names.length; i < n; ++i) {
    const key = names[i];
    if (i === n - 1) {
      // last
      return found[key];
    }
    found = key in found ? found[key] : {};
  }
  return undefined;
};

export function radioBehaviorByCheckbox<T extends { id: number | string }>(
  mode: 'single' | 'multiple',
  checked: boolean,
  elements: T[],
  newElement: T,
): T[] {
  if (mode === 'single') {
    return checked ? [newElement] : [];
  }

  checked
    ? elements.push(newElement)
    : remove(elements, e => e.id === newElement.id);
  return elements;
}
